import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-xs font-medium tracking-widest uppercase text-primary-500 bg-primary-50 px-3 py-1 rounded-full">
            平台介绍
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4 mb-3">
            {aboutData.title}
          </h2>
          <p className="text-lg md:text-xl text-secondary-500 font-medium mb-6">
            {aboutData.subtitle}
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto mb-10">
            {aboutData.description}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            {aboutData.highlights.map((item, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-lg p-6 border border-background-200/70 flex items-start gap-4"
              >
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-primary-500 text-lg"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}